import styled from '@emotion/styled';
import { Typography } from '@viewup/ui';
import Image from 'next/image';

export interface ViewupGuideBannerProps {
  onClick: () => void;
}

// 배경 #5BBDFF 는 Figma 변수 `color/background/surface5` 실측값 — 테마에 대응 토큰이 없어 리터럴을 쓴다.
const Root = styled.button`
  position: relative;
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 112px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 16px;
  overflow: hidden;
  background: #5bbdff;
  text-align: left;
  cursor: pointer;
`;

const TextBlock = styled.span`
  position: absolute;
  top: 27px;
  left: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

// 일러스트는 오른쪽 기준으로 고정해 폭이 줄어도 우측에 붙게 한다.
const Book = styled(Image)`
  position: absolute;
  top: 33px;
  right: 36px;
  pointer-events: none;
`;

const Star = styled(Image)`
  position: absolute;
  top: 11px;
  right: 138px;
  pointer-events: none;
`;

export const ViewupGuideBanner = ({ onClick }: ViewupGuideBannerProps) => (
  <Root onClick={onClick} type='button'>
    <TextBlock>
      <Typography as='span' color='text.primaryInverse' fontType='header2.bold'>
        뷰업 가이드
      </Typography>
      <Typography
        as='span'
        color='text.primaryInverse'
        css={{ lineHeight: '22px', whiteSpace: 'nowrap' }}
        fontType='body2.regular'
      >
        뷰업의 새로운 소식을 알려드려요.
      </Typography>
    </TextBlock>
    <Star
      alt=''
      aria-hidden
      height={45}
      src='/images/viewupGuide/guide-star.svg'
      unoptimized
      width={44.78}
    />
    <Book
      alt=''
      aria-hidden
      height={63.79}
      src='/images/viewupGuide/guide-book.svg'
      unoptimized
      width={112.53}
    />
  </Root>
);
